// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Documentary_documentarySection__9R\\+lY {
  background-color: #1a1a1a;
  color: white;
}

.Documentary_sectionHeader__gym1O {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 95%;
  margin: 0 auto; /* Adjusted margin */
}

.Documentary_sectionHeader__gym1O h2 {
  font-size: 20px;
  font-weight: 700;
}

.Documentary_viewAll__z6QS0 {
  color: white;
  text-decoration: none;
  font-size: 16px;
  opacity: 0.8;
}

/* Swiper specific styles */
.Documentary_swiper__aF3Ju {
  width: 100%;
  max-width: 95%; /* Limit Swiper width to match the design */
  margin: 0 auto; /* Center Swiper */
}

.Documentary_swiper-slide__wqlf3 {
  width: auto !important; /* Let Swiper handle the width */
  height: auto;
  flex-shrink: 0; /* Prevent slides from shrinking */
}

.Documentary_card__CRWvI {
  background-color: #242424;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.2s;
  height: 100%;
  position: relative;
  cursor: pointer;
}



.Documentary_thumbnailContainer__ZbuW5 {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
}

.Documentary_thumbnail__F15DN {
  position: absolute;
  top: 2px;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.Documentary_cardContent__8DJuj {
  padding: 1rem;
}

.Documentary_title__YlzB- {
  font-size: 14px;
  margin: 0 0 0.5rem 0;
  font-weight: 500;
}

.Documentary_metaInfo__khjMm {
  align-items: center;
  font-size: 0.8rem;
  color: #999;
  margin-bottom: 0.5rem;
}

.Documentary_youtubeIcon__98mkS {
  vertical-align: middle;
  margin-right: 4px;
  width: 16px !important;
  height: 16px !important;
  color: #ff0000;
}

.Documentary_dot__Dg7ep {
  margin: 0 0.5rem;
}

.Documentary_description__G\\+2bq {
  font-size: 10px;
  color: #999;
  margin-bottom: 1rem;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* Limit to 3 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}

.Documentary_watchButton__ynAxV {
  background-color: #ff0000;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.Documentary_watchButton__ynAxV:hover {
  background-color: #cc0000;
}

.Documentary_icon__4CEwg {
  width: 16px;
  height: 16px;
  color: #000;
  border-radius: 50%;
  background-color: #fff;
  padding: 5px;
}

/* Add to your Documentary.module.css file */
.Documentary_clickableTitle__k9YPX {
  cursor: pointer;
  color: white;
  }

  .Documentary_thumbnailContainer__ZbuW5 {
    position: relative;
    display: inline-block;
  }
  
  .Documentary_playIconWrapper__QbM1z {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }
  
  .Documentary_thumbnailContainer__ZbuW5:hover .Documentary_playIconWrapper__QbM1z,
  .Documentary_card__CRWvI.Documentary_clicked__cm6Lv .Documentary_playIconWrapper__QbM1z {
    opacity: 1;
  }
  
  .Documentary_playIcon__1jg4P {
    color: white;
    font-size: 40px;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 10px;
    border-radius: 50%;
  }
  
  
/* Media Queries */
@media screen and (max-width: 1024px) {
  .Documentary_swiper-slide__wqlf3 {
    width: calc(50% - 10px) !important; /* For 2 slides with spacing */
  }
}

@media screen and (max-width: 589px) {
  .Documentary_swiper-slide__wqlf3 {
    width: calc(100% - 10px) !important; /* For 1 slide with spacing */
  }
}

@media screen and (max-width: 480px) {
  .Documentary_documentarySection__9R\\+lY {
    padding: 0rem;
    max-width: 95%;
    margin: 0 auto;
  }
  .Documentary_sectionHeader__gym1O {
   margin: 0 ; /* Adjusted margin */
   padding: 0;
  }
  .Documentary_sectionHeader__gym1O h2 {
    font-size: 1.2rem;
    margin: 5px 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/video-pages/css/Documentary.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,cAAc,EAAE,oBAAoB;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,cAAc,EAAE,2CAA2C;EAC3D,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE,sBAAsB,EAAE,gCAAgC;EACxD,YAAY;EACZ,cAAc,EAAE,kCAAkC;AACpD;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;;;AAIA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB,EAAE,qBAAqB;EAC5C,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,YAAY;EACZ;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,6BAA6B;IAC7B,oBAAoB;EACtB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,oCAAoC;IACpC,aAAa;IACb,kBAAkB;EACpB;;;AAGF,kBAAkB;AAClB;EACE;IACE,kCAAkC,EAAE,8BAA8B;EACpE;AACF;;AAEA;EACE;IACE,mCAAmC,EAAE,6BAA6B;EACpE;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;IACd,cAAc;EAChB;EACA;GACC,UAAU,EAAE,oBAAoB;GAChC,UAAU;EACX;EACA;IACE,iBAAiB;IACjB,aAAa;IACb;AACJ","sourcesContent":[".documentarySection {\n  background-color: #1a1a1a;\n  color: white;\n}\n\n.sectionHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 95%;\n  margin: 0 auto; /* Adjusted margin */\n}\n\n.sectionHeader h2 {\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.viewAll {\n  color: white;\n  text-decoration: none;\n  font-size: 16px;\n  opacity: 0.8;\n}\n\n/* Swiper specific styles */\n.swiper {\n  width: 100%;\n  max-width: 95%; /* Limit Swiper width to match the design */\n  margin: 0 auto; /* Center Swiper */\n}\n\n.swiper-slide {\n  width: auto !important; /* Let Swiper handle the width */\n  height: auto;\n  flex-shrink: 0; /* Prevent slides from shrinking */\n}\n\n.card {\n  background-color: #242424;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: transform 0.2s;\n  height: 100%;\n  position: relative;\n  cursor: pointer;\n}\n\n\n\n.thumbnailContainer {\n  position: relative;\n  width: 100%;\n  padding-top: 56.25%; /* 16:9 Aspect Ratio */\n}\n\n.thumbnail {\n  position: absolute;\n  top: 2px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n.cardContent {\n  padding: 1rem;\n}\n\n.title {\n  font-size: 14px;\n  margin: 0 0 0.5rem 0;\n  font-weight: 500;\n}\n\n.metaInfo {\n  align-items: center;\n  font-size: 0.8rem;\n  color: #999;\n  margin-bottom: 0.5rem;\n}\n\n.youtubeIcon {\n  vertical-align: middle;\n  margin-right: 4px;\n  width: 16px !important;\n  height: 16px !important;\n  color: #ff0000;\n}\n\n.dot {\n  margin: 0 0.5rem;\n}\n\n.description {\n  font-size: 10px;\n  color: #999;\n  margin-bottom: 1rem;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 3; /* Limit to 3 lines */\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n}\n\n.watchButton {\n  background-color: #ff0000;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.watchButton:hover {\n  background-color: #cc0000;\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n  color: #000;\n  border-radius: 50%;\n  background-color: #fff;\n  padding: 5px;\n}\n\n/* Add to your Documentary.module.css file */\n.clickableTitle {\n  cursor: pointer;\n  color: white;\n  }\n\n  .thumbnailContainer {\n    position: relative;\n    display: inline-block;\n  }\n  \n  .playIconWrapper {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n    pointer-events: none;\n  }\n  \n  .thumbnailContainer:hover .playIconWrapper,\n  .card.clicked .playIconWrapper {\n    opacity: 1;\n  }\n  \n  .playIcon {\n    color: white;\n    font-size: 40px;\n    background-color: rgba(0, 0, 0, 0.6);\n    padding: 10px;\n    border-radius: 50%;\n  }\n  \n  \n/* Media Queries */\n@media screen and (max-width: 1024px) {\n  .swiper-slide {\n    width: calc(50% - 10px) !important; /* For 2 slides with spacing */\n  }\n}\n\n@media screen and (max-width: 589px) {\n  .swiper-slide {\n    width: calc(100% - 10px) !important; /* For 1 slide with spacing */\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .documentarySection {\n    padding: 0rem;\n    max-width: 95%;\n    margin: 0 auto;\n  }\n  .sectionHeader {\n   margin: 0 ; /* Adjusted margin */\n   padding: 0;\n  }\n  .sectionHeader h2 {\n    font-size: 1.2rem;\n    margin: 5px 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"documentarySection": `Documentary_documentarySection__9R+lY`,
	"sectionHeader": `Documentary_sectionHeader__gym1O`,
	"viewAll": `Documentary_viewAll__z6QS0`,
	"swiper": `Documentary_swiper__aF3Ju`,
	"swiper-slide": `Documentary_swiper-slide__wqlf3`,
	"card": `Documentary_card__CRWvI`,
	"thumbnailContainer": `Documentary_thumbnailContainer__ZbuW5`,
	"thumbnail": `Documentary_thumbnail__F15DN`,
	"cardContent": `Documentary_cardContent__8DJuj`,
	"title": `Documentary_title__YlzB-`,
	"metaInfo": `Documentary_metaInfo__khjMm`,
	"youtubeIcon": `Documentary_youtubeIcon__98mkS`,
	"dot": `Documentary_dot__Dg7ep`,
	"description": `Documentary_description__G+2bq`,
	"watchButton": `Documentary_watchButton__ynAxV`,
	"icon": `Documentary_icon__4CEwg`,
	"clickableTitle": `Documentary_clickableTitle__k9YPX`,
	"playIconWrapper": `Documentary_playIconWrapper__QbM1z`,
	"clicked": `Documentary_clicked__cm6Lv`,
	"playIcon": `Documentary_playIcon__1jg4P`
};
export default ___CSS_LOADER_EXPORT___;
